import { apiClient } from '@/services/apiClient';
import type { ApiEnvelope } from '@/types/api';
import type {
  AuthResponse,
  AuthUserResponse,
  ChangeLanguageRequest,
  ChangePasswordRequest,
  ForgotPasswordRequest,
  LoginRequest,
  RegisterRequest,
  RequestOtpRequest,
  ResetPasswordRequest,
  SessionResponse,
  VerifyOtpRequest,
} from '../types/authTypes';

/**
 * authApi.ts - one function per backend endpoint, each fully typed. Hooks
 * (useLogin, useRegister, ...) call these; components never call
 * `apiClient` directly - this is the only file that knows the exact
 * request/response shape of each auth endpoint.
 */
export const authApi = {
  register: (payload: RegisterRequest) => apiClient.post<ApiEnvelope<null>>('/auth/register', payload),

  login: (payload: LoginRequest) => apiClient.post<ApiEnvelope<AuthResponse>>('/auth/login', payload),

  requestOtp: (payload: RequestOtpRequest) => apiClient.post<ApiEnvelope<null>>('/auth/request-otp', payload),

  verifyOtp: (payload: VerifyOtpRequest) => apiClient.post<ApiEnvelope<null>>('/auth/verify-otp', payload),

  forgotPassword: (payload: ForgotPasswordRequest) =>
    apiClient.post<ApiEnvelope<null>>('/auth/forgot-password', payload),

  resetPassword: (payload: ResetPasswordRequest) =>
    apiClient.post<ApiEnvelope<null>>('/auth/reset-password', payload),

  logout: (refreshToken: string) => apiClient.post<ApiEnvelope<null>>('/auth/logout', { refreshToken }),

  me: () => apiClient.get<ApiEnvelope<AuthUserResponse>>('/users/me'),

  changeLanguage: (payload: ChangeLanguageRequest) => apiClient.put<ApiEnvelope<null>>('/users/me/language', payload),

  changePassword: (payload: ChangePasswordRequest) => apiClient.put<ApiEnvelope<null>>('/users/me/password', payload),

  listSessions: () => apiClient.get<ApiEnvelope<SessionResponse[]>>('/users/me/sessions'),

  revokeSession: (sessionId: string) => apiClient.delete<ApiEnvelope<null>>(`/users/me/sessions/${sessionId}`),
};
